import { RepeatableState } from '@/store/modules/repeatable/state';
import { MutationTree } from 'vuex';
import { RepeatableDataMap } from '@/store/modules/repeatable/types';

export type Mutations = {
  setData(state: RepeatableState, data: RepeatableDataMap): void;
};

export const mutations: MutationTree<RepeatableState> & Mutations = {
  setData(state: RepeatableState, data: RepeatableDataMap) {
    state.data = data;
  }
};
